import { useTranslation } from "react-i18next"

function Loading() {

    const [t, i18n] = useTranslation(["global"])

    let content =
        <section>
            <span className="">{t("helper.loading")}...</span>
            <div className="spinner-border hidden text-light" role="status"></div>
        </section>

    return content
}

export default Loading